import React from "react";
import { Link, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { logoutAction } from "../actions/authActions";
import Image from "./Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLocationDot,
  faPaperPlane,
  faUser,
  faArrowRightFromBracket,
} from "@fortawesome/free-solid-svg-icons";

const UserPanel = ({ userData, logoutAction }) => {
  const { t } = useTranslation();
  const location = useLocation();

  const isActive = (path) => location.pathname === path;
  const renderUserInfo = () => {
    if (userData) {
      return (
        <>
          <Image src={userData.profile_pic} />
          <Link className="user-fullname">
            {`${userData.first_name} ${userData.last_name}`}

            <br />

            <span>{t(`ID - ${userData.id ? userData.id : "..."}`)}</span>
          </Link>
        </>
      );
    }
  };
  return (
    <div className="userpanel-left-container">
      <div className="user-info-mini-container2">{renderUserInfo()}</div>

      <div className="left-menu">
        <ul className="center">
          {/* <li className={isActive("/add/new/post") ? "active" : ""}>
            <Link to="/add/new/post">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g stroke="#5E5E5E">
                  <path d="M8 12h8M12 16V8M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7z"></path>
                </g>
              </svg>
              {t("Add post")}
            </Link>
          </li> */}

          {/* <li className={isActive("/active/posts") ? "active" : ""}>
            <Link to="/active/posts">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <g stroke="#5E5E5E">
                  <path d="M9 22h6c5 0 7-2 7-7V9c0-5-2-7-7-7H9C4 2 2 4 2 9v6c0 5 2 7 7 7z"></path>
                  <path d="M18 7.75v6.75c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2V7.75c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2zM19 15.75h-1M6 15.75H5"></path>
                  <path d="M18 14v-3c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3"></path>
                  <path d="M18 14.5v1.25h-3.5a2.5 2.5 0 01-5 0H6V14.5c0-1.1.9-2 2-2h8c1.1 0 2 .9 2 2z"></path>
                </g>
              </svg>
              {t("Active Posts")}
            </Link>
          </li> */}

          <li className={isActive("/me") ? "active" : ""}>
            <Link to="/me">
              <FontAwesomeIcon icon={faUser} />
              {t("My Profile")}
            </Link>
          </li>

          <li className={isActive("/generateqr") ? "active" : ""}>
            <Link to="/generateqr">
              <FontAwesomeIcon icon={faLocationDot} />
              {t("my tags")}
            </Link>
          </li>

          {/* <li className={isActive("/favorite") ? "active" : ""}>
            <Link to="/favorite">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <path
                  stroke="#5E5E5E"
                  d="M12.62 20.81c-.34.12-.9.12-1.24 0C8.48 19.82 2 15.69 2 8.69 2 5.6 4.49 3.1 7.56 3.1c1.82 0 3.43.88 4.44 2.24a5.53 5.53 0 014.44-2.24C19.51 3.1 22 5.6 22 8.69c0 7-6.48 11.13-9.38 12.12z"
                ></path>
              </svg>
              {t("Favorite")}
            </Link>
          </li> */}

          <li className={isActive("/messages") ? "active" : ""}>
            <Link to="/messages">
              <FontAwesomeIcon icon={faPaperPlane} />
              {t("Messages")}
            </Link>
          </li>

          <li>
            <Link onClick={() => logoutAction()}>
              <FontAwesomeIcon icon={faArrowRightFromBracket} />
              {t("logout")}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData.userData,
  };
};
export default connect(mapStateToProps, { logoutAction })(UserPanel);
